@if (!invalid) {
  <span class="number">{{ area | number }}</span>
  <span class="number-type">{{ units }}</span>
} @else {
  <span class="number">--</span>
}
